/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, useState, useEffect } from "react";
import avtar from "../images/team-2.jpg";
import Breadcrumb from "./breadcrumb";
import { NavLink } from "react-router-dom";
import {
  Row,
  Col,
  Badge,
  Dropdown,
  Button,
  List,
  Avatar,
  Input,
  Drawer,
  Typography,
  Switch,
  Tag,
  Popover,
  Menu,
} from "antd";
import {
  SearchOutlined,
  StarOutlined,
  TwitterOutlined,
  FacebookFilled,
  DownOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import Theme from "../theme/Theme";
import { FaPowerOff, FaQuestionCircle } from "react-icons/fa";
import { HiMiniBars3 } from "react-icons/hi2";
import { RxCross2 } from "react-icons/rx";
import { extractToken } from "../../utils/localStorage";
import { headerMenuItems, roleAccess } from "../../utils/menu-items";
import auth from "../../services/auth";
import notification from "../../services/notification";
import Notification from "../notification/Notification";
import { capitalizeFirstLetter } from "../../utils/utils";
import { withRouter } from "react-router-dom";
import { BsQuestionCircleFill } from "react-icons/bs";
import { globalRoles } from "../../utils/roles";
import { io } from 'socket.io-client';
import { domain } from '../../utils/domainUrls';
import { notify } from "../../utils/helper";

const ButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #1890ff;
  }
  .ant-btn-success {
    background-color: #52c41a;
  }
  .ant-btn-yellow {
    background-color: #fadb14;
  }
  .ant-btn-black {
    background-color: #262626;
    color: #fff;
    border: 0px;
    border-radius: 5px;
  }
  .ant-switch-active {
    background-color: #1890ff;
  }
`;
const { Title, Text } = Typography;
const bell = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      d="M10 2C6.68632 2 4.00003 4.68629 4.00003 8V11.5858L3.29292 12.2929C3.00692 12.5789 2.92137 13.009 3.07615 13.3827C3.23093 13.7564 3.59557 14 4.00003 14H16C16.4045 14 16.7691 13.7564 16.9239 13.3827C17.0787 13.009 16.9931 12.5789 16.7071 12.2929L16 11.5858V8C16 4.68629 13.3137 2 10 2Z"
      fill="#111827"
    ></path>
    <path
      d="M10 18C8.34315 18 7 16.6569 7 15H13C13 16.6569 11.6569 18 10 18Z"
      fill="#111827"
    ></path>
  </svg>,
];
const wifi = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 107 107"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="logo-spotify" fill="#2EBD59" fillRule="nonzero">
        <path
          d="M53.5,0 C23.9517912,0 0,23.9517912 0,53.5 C0,83.0482088 23.9517912,107 53.5,107 C83.0482088,107 107,83.0482088 107,53.5 C107,23.9554418 83.0482088,0.00365063118 53.5,0 Z M78.0358922,77.1597407 C77.0757762,78.7368134 75.0204708,79.2296486 73.4506994,78.2695326 C60.8888775,70.5922552 45.0743432,68.8582054 26.4524736,73.1111907 C24.656363,73.523712 22.8675537,72.3993176 22.458683,70.6032071 C22.0461617,68.8070966 23.1669055,67.0182873 24.9666667,66.6094166 C45.3444899,61.9548618 62.8273627,63.9590583 76.9297509,72.5745479 C78.4995223,73.5419652 78.9996588,75.5899693 78.0358922,77.1597407 L78.0358922,77.1597407 Z M84.5814739,62.5973729 C83.373115,64.5614125 80.8030706,65.1747185 78.8426817,63.9700102 C64.4664961,55.1318321 42.5408052,52.5727397 25.5325145,57.7347322 C23.3275333,58.4027977 20.9984306,57.1579324 20.3267144,54.9566018 C19.6622996,52.7516206 20.9071648,50.4261685 23.1084954,49.7544524 C42.5371546,43.858683 66.6933811,46.7134766 83.2051859,56.8622313 C85.1692255,58.0705902 85.7898328,60.636984 84.5814739,62.5973729 Z M85.1436711,47.4253497 C67.8980894,37.1853292 39.4523712,36.2434664 22.9880246,41.2375299 C20.3449676,42.0406687 17.5485841,40.5475606 16.7490959,37.9045036 C15.9496076,35.2614466 17.4390652,32.4650631 20.0857728,31.6619243 C38.9850904,25.9267827 70.3987718,27.0329239 90.2509041,38.8171614 C92.627465,40.2299556 93.4087001,43.3001365 91.9995565,45.6730467 C90.5940635,48.0532583 87.5165814,48.838144 85.1436711,47.4253497 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>,
];
const credit = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fill="#1890FF"
      d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
    ></path>
    <path
      fill="#1890FF"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
    ></path>
  </svg>,
];
const clockicon = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V10C9 10.2652 9.10536 10.5196 9.29289 10.7071L12.1213 13.5355C12.5118 13.9261 13.145 13.9261 13.5355 13.5355C13.9261 13.145 13.9261 12.5118 13.5355 12.1213L11 9.58579V6Z"
      fill="#111827"
    ></path>
  </svg>,
];
const data = [
  {
    title: "New message from Sophie",
    description: <>{clockicon} 2 days ago</>,

    avatar: avtar,
  },
  {
    title: "New album by Travis Scott",
    description: <>{clockicon} 2 days ago</>,

    avatar: <Avatar shape="square">{wifi}</Avatar>,
  },
  {
    title: "Payment completed",
    description: <>{clockicon} 2 days ago</>,
    avatar: <Avatar shape="square">{credit}</Avatar>,
  },
];

const menu = (
  <List
    min-width="100%"
    className="header-notifications-dropdown "
    itemLayout="horizontal"
    dataSource={data}
    renderItem={(item) => (
      <List.Item>
        <List.Item.Meta
          avatar={<Avatar shape="square" src={item.avatar} />}
          title={item.title}
          description={item.description}
        />
      </List.Item>
    )}
  />
);
const logsetting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];
const profile = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
      fill="#111827"
    ></path>
  </svg>,
];
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

const HeaderContainer = styled.div`
  height: 64px;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
  position: relative;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  // padding: 0 24px;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 23px;

  @media (max-width: 1028px) {
    .nav-link {
      display: none;
    }
  }

  a {
    color: var(--text-navbar-color);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.875rem;
    transition: color 0.3s ease;

    &:hover,
    &.active {
      color: #8a3ef4 !important;
    }
    &.active {
      font-weight: 600;
    }
  }
`;

const LogoContainer = styled.div`
  width: 150px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 1028px) {
    display: none;
  }

  a {
    color: var(--text-navbar-color);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.875rem;
    transition: color 0.3s ease;

    &:hover,
    &.active {
      color: #8a3ef4 !important;
      font-weight: 500;
    }
  }
`;

const UserContainer = styled.div`
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &.loading {
    border: 2px solid transparent !important;
    background: linear-gradient(var(--primary-bg), var(--primary-bg)) padding-box,
                linear-gradient(45deg, #8a3ef4, #ff6b6b, #4ecdc4, #45a049, #8a3ef4) border-box !important;
    background-size: 400% 400%;
    animation: borderRainbow 3s ease-in-out infinite;
    box-shadow: 0 0 20px rgba(138, 62, 244, 0.3);
  }

  &.loading::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 25px;
    background: linear-gradient(45deg, #8a3ef4, #ff6b6b, #4ecdc4, #45a049);
    background-size: 400% 400%;
    animation: borderRainbow 2s linear infinite;
    z-index: -1;
    opacity: 0.5;
    filter: blur(4px);
  }

  @keyframes borderRainbow {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const MobileMenuIcon = styled.div`
  display: none;
  margin-right: 10px;

  @media (max-width: 1028px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  background: var(--primary-bg);
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  border: 1px solid var(--border-color);

  @media (max-width: 1028px) {
    display: ${(props) => (props.isOpen ? "block" : "none")};
  }

  a {
    display: block;
    padding: 10px 0;
    color: var(--text-navbar-color);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.875rem;
    transition: color 0.3s ease;

    &:hover,
    &.active {
      color: #8a3ef4 !important;
    }
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // margin-right: -15px;
  // padding: 4px 8px;
  border-radius: 4px; 
  background: var(--primary-bg);
  // background: var(--profile-bg);
  cursor: pointer;
  // padding-right: 14px;

  .user-initials {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: var(--border-muted-color);
    color: rgb(193, 170, 226);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
  }

  .user-role {
    font-size: 0.875rem;
    color: var(--text-color);
    padding-right: 6px;
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
  .loader-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(45deg, #8a3ef4, #ff6b6b);
    animation: pulse 1.5s ease-in-out infinite;
    box-shadow: 0 0 15px rgba(138, 62, 244, 0.4);
  }

  .loader-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .loader-text {
    font-size: 0.875rem;
    color: var(--text-color);
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    background: linear-gradient(45deg, #8a3ef4, #ff6b6b, #4ecdc4);
    background-size: 300% 300%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: gradientShift 2s ease-in-out infinite;
  }

  .loader-dots {
    animation: loadingDots 1.2s infinite;
    font-weight: bold;
    background: linear-gradient(45deg, #8a3ef4, #ff6b6b, #4ecdc4);
    background-size: 300% 300%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: gradientShift 2s ease-in-out infinite, loadingDots 1.2s infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 0 15px rgba(138, 62, 244, 0.4);
    }
    50% {
      transform: scale(1.1);
      box-shadow: 0 0 25px rgba(138, 62, 244, 0.8);
    }
  }

  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  @keyframes loadingDots {
    0%, 20% {
      opacity: 0;
      transform: scale(0.8);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(0.8);
    }
  }

  .loader-dots:nth-child(2) {
    animation-delay: 0.2s;
  }

  .loader-dots:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

class HeaderTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      isLoading: false,
    };
    this.socket = null;
  }

  componentDidMount() {
    this.setupSocket();
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  setupSocket = () => {
    const user = extractToken();
    if (user?.sub) {
      try {
        this.socket = io(domain);
        this.socket.on(`${user.sub.toString()}_cloned`, (payload) => { 
          // console.log("payload:", payload);
          
                    if (payload?.message === "pending") {
            // Start showing loader
            this.setState({ 
              isLoading: true
            });
          } else if (payload?.message === "completed") {
            // Show success notification
            notify("success", "Great! Video Cloned Successfully!");
            
            // Hide loader after showing completion
            setTimeout(() => {
              this.setState({ 
                isLoading: false
              });
            }, 1500);
          }
        });
      } catch (err) {
        console.error('Socket connection error:', err);
      }
    }
  };

  // Method to start loading
  startLoading = () => {
    this.setState({ isLoading: true });
  };

  // Method to stop loading
  stopLoading = () => {
    this.setState({ isLoading: false });
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  handleLogout = () => {
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };

  handleProfileClick = () => {
    this.props.history.push("/my-profile");
  };
  handleClick = () => {
    this.props.history.push("/pages/support")
  }

  renderLoader = () => {
    return (
      <LoaderContainer>
        <div className="loader-circle">
          <div className="loader-spinner"></div>
        </div>
        <div className="loader-text">
          Cloning Video
          <span className="loader-dots">.</span>
          <span className="loader-dots">.</span>
          <span className="loader-dots">.</span>
        </div>
      </LoaderContainer>
    );
  };

  renderUserInfo = (user) => {
    return (
      <UserInfo onClick={this.handleProfileClick}>
        <div className="user-initials">
          {user.name
            ? `${capitalizeFirstLetter(user.name.charAt(0))}`
            : "U"}
        </div>
        {(user?.role === globalRoles.PHYSICIAN && user?.boardMember) ? (
          <span>
            <Tag className="cursor board-member-tag">BM</Tag>
          </span>
        ) : (
          <div className="user-role">{user?.role === globalRoles.OWNER ? globalRoles?.PHYSICIAN: user?.role}</div>
        )}
      </UserInfo>
    );
  };

  render() {
    const { isMobileMenuOpen, isLoading } = this.state;
    const user = extractToken();

    const content = (
      <Row className="d-flex justify-start" style={{ width: "220px" }}>
        <Col className="d-flex justify-start" span={24}>
          <div>
            <Avatar
              size={38}
              style={{
                marginRight: "8px",
                backgroundColor: "var(--border-color)",
                color: "var(--primary-text-color)",
              }}
            >
              {capitalizeFirstLetter(user?.name?.[0])}
            </Avatar>
          </div>
          <div>
            <div className="d-flex justify-start font-18 text-primary">
              <span>{capitalizeFirstLetter(user?.name)}</span>
            </div>
            <div className="d-flex justify-start font-13 text-primary">
              <span className="d-flex justify-start" style={{ gap: "5px" }}>Role: {user?.role}
                {user?.boardMember && (
                  <span>
                    <Tag className="cursor board-member-tag" style={{ margin: 0 }}>BM</Tag>
                  </span>
                )}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    );
    // Filter menu items based on user role
    const filteredMenuItems = headerMenuItems.filter(
      (item) => item.visible && roleAccess(user?.role, item.roles)
    );


    const helpPopover = (
      <div>
        <p className="text-primary" style={{cursor:'pointer'}} onClick={() =>this.props.history.push('/pages/support')}>
           Help Center
        </p>
        <p className="text-primary" style={{cursor:'pointer'}} onClick={() =>{window.location.href = 'https://www.meducate.ai/privacy-policy'}}>

           Privacy Policy
        </p>
        <p className="text-primary" style={{cursor:'pointer'}} onClick={() =>{window.location.href = "https://www.meducate.ai/terms-of-service"}}>

          Terms of Service 
        </p>

      </div>
    )

    return (
      <HeaderContainer>
        <HeaderContent>
          <LeftContainer>
            <LogoContainer>
              {filteredMenuItems.length > 0 && (
                <NavLink to={filteredMenuItems[0]?.path}>
                  <img src="/MUC_logo.png" alt="Logo" />
                </NavLink>
              )}
            </LogoContainer>
            {filteredMenuItems.map((item) => {
              if (item.children && item.children.length > 0) {
                const menu = (
                  <Menu>
                    {item.children.map((child) => 
                      roleAccess(user?.role, child.roles) && (
                        <Menu.Item key={child.id}>
                          <NavLink to={child.path}>{child.title}</NavLink>
                        </Menu.Item>
                      )
                    )}
                  </Menu>
                );
                return (
                  <Dropdown overlay={menu} key={item.id} trigger={['hover']}>
                    <a className="nav-link" onClick={(e) => e.preventDefault()}>
                      {item.title} <DownOutlined style={{ fontSize: "10px", marginLeft: "4px" }} />
                    </a>
                  </Dropdown>
                );
              }

              return (
                <NavLink
                  key={item.id}
                  to={item.path}
                  exact={item.path === "/dashboard"}
                  className="nav-link"
                >
                  {item?.title === "Physicians" && user?.role === globalRoles.LIBRARY_MANAGER
                    ? "Voice Library"
                    : item.title}
                </NavLink>
              );
            })}
          </LeftContainer>

          <MobileMenuIcon>
            <Theme />
            {user && (
              <UserInfo>
                {/* <Popover
                  content={content}
                  trigger="click"
                > */}
                <div className="user-initials" onClick={this.handleProfileClick}>
                  {user.name
                    ? `${capitalizeFirstLetter(user.name.charAt(0))}`
                    : "U"}
                </div>
                {/* </Popover> */}
              </UserInfo>
            )}
            < BsQuestionCircleFill className="cursor" size={20} onClick={this.handleClick} />
            <Notification />
            {isMobileMenuOpen ? (
              <RxCross2
                style={{ cursor: "pointer" }}
                size={24}
                onClick={this.toggleMobileMenu}
              />
            ) : (
              <HiMiniBars3
                style={{ cursor: "pointer" }}
                size={24}
                onClick={this.toggleMobileMenu}
              />
            )}
          </MobileMenuIcon>

          <NavContainer>
            {/* {filteredMenuItems.map((item) => (
              <NavLink
                key={item.id}
                to={item.path}
                exact={item.path === "/dashboard"}
              >
              {(item?.title === "Physicians" && user?.role === globalRoles.LIBRARY_MANAGER) ? (
                "Voice Library"
              ) : (item.title)}
              </NavLink>
            ))} */}
            <Theme />
            {user && (
              <UserContainer
                className={isLoading ? "loading" : ""}
                style={{
                  border: "1px solid var(--border-color)",
                  padding: "3px 5px",
                  borderRadius: "25px",
                  backgroundColor: "var(--primary-bg)"
                }}
              >
                {isLoading ? this.renderLoader() : this.renderUserInfo(user)}
              </UserContainer>
            )}

            
            <Popover placement="bottomLeft" title={null} content={helpPopover}>
              <BsQuestionCircleFill className="cursor" size={20} />
            </Popover>
            <Notification />
            <div style={{ cursor: "pointer" }} onClick={this.handleLogout}>
              <div style={{ paddingTop: "6px" }}>
                <FaPowerOff size={22} />


              </div>
            </div>
          </NavContainer>

          <MobileMenu isOpen={isMobileMenuOpen}>
            {filteredMenuItems.map((item) => {
              if (item.children && item.children.length > 0) {
                return (
                  <div key={item.id}>
                    <div
                      style={{
                        padding: "10px 0",
                        fontWeight: "500",
                        color: "var(--text-navbar-color)",
                      }}
                    >
                      {item.title}
                    </div>
                    <div style={{ paddingLeft: "20px" }}>
                      {item.children.map(
                        (child) =>
                          roleAccess(user?.role, child.roles) && (
                            <NavLink
                              key={child.id}
                              to={child.path}
                              onClick={this.toggleMobileMenu}
                            >
                              {child.title}
                            </NavLink>
                          )
                      )}
                    </div>
                  </div>
                );
              }
              return (
                <NavLink
                  key={item.id}
                  to={item.path}
                  exact={item.path === "/dashboard"}
                  onClick={this.toggleMobileMenu}
                >
                  {item?.title === "Physicians" &&
                  user?.role === globalRoles.LIBRARY_MANAGER
                    ? "Voice Library"
                    : item.title}
                </NavLink>
              );
            })}
            <div style={{ cursor: "pointer" }} onClick={this.handleLogout}>
              <div style={{ paddingTop: "6px" }}>
                <FaPowerOff size={19} />
              </div>
            </div>
          </MobileMenu>
        </HeaderContent>
      </HeaderContainer>
    );
  }
}

export default withRouter(HeaderTop);
